import script from "./MyINGA.vue?vue&type=script&setup=true&lang=js"
export * from "./MyINGA.vue?vue&type=script&setup=true&lang=js"

import "./MyINGA.vue?vue&type=style&index=0&id=a5310a04&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5310a04"]])

export default __exports__